const PRECISION_TYPES = new Set(['number', 'percent']);

const DEFAULTS = {
  display: 0,
  tooltip: 2,
};

function getMetricPrecision(metric, context = 'display') {
  const type = metric?.type || 'number';
  if (!PRECISION_TYPES.has(type)) {
    return undefined;
  }
  const field = context === 'tooltip' ? 'tooltipPrecision' : 'precision';
  const value = metric?.[field];
  return value != null ? value : DEFAULTS[context];
}

module.exports = {
  getMetricPrecision,
  DEFAULTS,
};
